import { render, staticRenderFns } from "./ControlTabOutput.vue?vue&type=template&id=46becd10&scoped=true"
import script from "./ControlTabOutput.vue?vue&type=script&lang=ts"
export * from "./ControlTabOutput.vue?vue&type=script&lang=ts"
import style0 from "./ControlTabOutput.vue?vue&type=style&index=0&id=46becd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46becd10",
  null
  
)

export default component.exports